import { ChaseType } from "@/app/types/chaseType";
import { Image, Text, Box, Flex, SimpleGrid } from "@chakra-ui/react";
import { FaQuestion } from "react-icons/fa6";

type Props = {
    chase: ChaseType
};

export default function CreaturesGrid({chase}: Props) {
    const discoveredCreatures = chase.creatures || [];
    const remainingCoords = (chase && chase.coords && chase.coords.length) || ((chase && chase.creatures && chase.creatures.length)?0:5);

    return (
        <SimpleGrid columns={5} spacing={3} px={3} pb={3} w="full">
            <Flex justifyContent="center" key={"main"} bg='black' height='80px' alignContent="center" position="relative" borderRadius={5}>
                <Image
                    src={"/images/chase.jpeg"} // Assurez-vous que chaque créature a une propriété "image"
                    alt={"chase"} // Assurez-vous que chaque créature a une propriété "name"
                />
                <Text position="absolute" fontWeight="bold" bottom="1" bg="white" color="black" borderRadius={6} px={2} fontSize={"0.8em"}>{discoveredCreatures.length}/{discoveredCreatures.length+remainingCoords}</Text>
            </Flex>
        {/* Afficher les créatures découvertes */}
        {discoveredCreatures && discoveredCreatures.map((creature, index) => (
            <Box key={index} bg='gray.700' height='80px' alignContent="center" borderRadius={5} border={creature.type=="LEGENDARY"?"3px solid #eba628":"2px solid white"}>
                <Image
                    src={creature.url} // Assurez-vous que chaque créature a une propriété "image"
                    alt={creature.name} // Assurez-vous que chaque créature a une propriété "name"
                    style={{ margin: "auto", height: "100%" }}
                />
            </Box>
        ))}

        {/* Compléter avec des cartes "?" */}
        {Array.from({ length: remainingCoords }).map((_ :any, index) => (
            <Box key={index + discoveredCreatures.length} bg='gray.900' height='80px' alignContent="center" borderRadius={5} border="2px solid #919191">
                <FaQuestion style={{ margin: "auto" }} fontSize="3em" color="white" opacity={0.6}/>
            </Box>
        ))}
        </SimpleGrid>
    );
}